import { render } from "./book-desc.vue?vue&type=template&id=a79ba7b6&scoped=true"
import script from "./book-desc.vue?vue&type=script&lang=js"
export * from "./book-desc.vue?vue&type=script&lang=js"

import "./book-desc.vue?vue&type=style&index=0&id=a79ba7b6&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79ba7b6"]])

export default __exports__